export function consolidateCategories(data: any) {
  if (!data) return {};

  const consolidatedObject: Record<string, number> = {};
  for (const category in data) {
    // Check for both 'labels' and 'lables' spellings
    const labels = data[category]?.labels || data[category]?.lables;
    if (labels && Array.isArray(labels)) {
      labels.forEach((label: string, index: number) => {
        if (data[category]?.data?.[index] !== undefined) {
          consolidatedObject[label] = Number(data[category].data[index]);
        }
      });
    }
  }
  return consolidatedObject;
}

export function getMatchingScores(
  competencies: any[],
  userCompetencies: Record<string, number>
) {
  if (!Array.isArray(competencies) || !userCompetencies) return [];

  const scores: number[] = [];
  competencies?.forEach((competency: any) => {
    const name = competency?.competency?.name;
    if (name && userCompetencies[name] !== undefined) {
      scores.push(Number(userCompetencies[name]));
    }
  });
  return scores;
}

export function extractCompetencyInfo(competencies: any[]) {
  const names: any[] = [];
  const descriptions: any[] = [];
  const minScores: any[] = [];

  competencies?.forEach((competency: { competency?: any; min_score?: any }) => {
    const { name, description } = competency.competency;
    const { min_score } = competency;

    names.push(name);
    descriptions.push(description);
    minScores.push(min_score);
  });

  return {
    names,
    descriptions,
    minScores
  };
}
export const getComparedData = (
  candidateComp: any[],
  profileComp: Record<string, number> | any[]
): any[] => {
  if (!Array.isArray(candidateComp)) {
    console.error('Expected array for candidateComp');
    return [];
  }

  if (!profileComp) {
    console.error('Expected profileComp to be defined');
    return [];
  }

  // If profileComp is a Record (object), convert it to array format
  const profileData = Array.isArray(profileComp)
    ? profileComp
    : Object.entries(profileComp).map(([competency_id, score]) => ({
        competency_id,
        score
      }));

  const profileCompIds = profileData.map(
    (el: any) => el?.competency?.id || el?.competency_id
  );

  const arr: any[] = [];
  profileCompIds.forEach((item) => {
    const element = candidateComp.find(
      (el) => el?.competency_id === item || el?.competency?.id === item
    );
    if (element) {
      arr.push(element);
    }
  });
  return arr;
};



export function getCompetencyDescriptions(competencies: any) {
  const descriptions: { name: any; description: any; }[] = [];

  competencies.forEach((competency: { name: any; description: any; }) => {
      descriptions.push({
          name: competency.name,
          description: competency.description
      });
  });

  return descriptions;
}

export function calculateMatchPercentage(arr1: number[], arr2: number[]) {
  if (arr1?.length !== arr2?.length) {
    console.error('Arrays must be of the same length');
    return null;
  }

  const arrayLength = arr1.length;
  const basePercent = 100 / arrayLength;
  let totalPercent = 0;

  for (let i = 0; i < arrayLength; i++) {
    if (Number(arr1[i]) >= Number(arr2[i])) {
      totalPercent += basePercent;
    } else {
      totalPercent += (Number(arr1[i]) / Number(arr2[i])) * basePercent;
    }
  }

  return totalPercent.toFixed(0);
}

export const getSumOfArray = (array: number[]) => {
  return array.reduce((accumulator, currentValue) => {
    return Number(accumulator) + Number(currentValue);
  }, 0);
};
